import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: '52-Week Dance Teaching Planner',
  value: '12',
  desc: 'A complete year-round planning system that turns your 100 classes into a connected, progressive teaching program. Each of the 52 weeks includes a suggested technical focus, teaching objective, class direction, progression idea, and review priority across Jazz, Contemporary, and Musical Theatre.',
  benefit: 'No preparation needed. Open it, follow it, and teach with a real annual structure.'
}, {
  id: '02',
  title: 'The Ultimate Dance Cueing & Correction Library',
  value: '12',
  desc: 'A practical library of ready-to-say teaching cues for every moment of your class — alignment, turns, kicks, leaps, floor work, traveling sequences, rhythm, dynamics, stage presence, and performance quality. Includes supportive correction language for both beginner and intermediate dancers.',
  benefit: 'The words are already there. You just say them.'
}, {
  id: '03',
  title: '30 Emergency Dance Classes',
  value: '12',
  desc: '30 fully structured backup classes for the days when there is no time to plan — substitute requests, last-minute schedule changes, mixed-level groups, small classes, or low-energy sessions. Includes Jazz, Contemporary, and Musical Theatre options across 30, 45, and 60-minute formats.',
  benefit: 'You will never walk into a class unprepared again. Open, choose, teach.'
}, {
  id: '04',
  title: 'The Dance Music, Counts & Tempo Guide',
  value: '10',
  desc: 'A practical guide that helps you choose music faster, map 8-counts with clarity, and match tempo to every class section. Includes practical worksheets for mapping counts, accents, transitions, and musical changes before you even enter the studio.',
  benefit: 'Practical, fast, and immediately useful — every time you plan a class.'
}, {
  id: '05',
  title: 'Dance Student Progress & Assessment Toolkit',
  value: '12',
  desc: 'A complete professional system for tracking student progress across Jazz, Contemporary, and Musical Theatre. Includes student progress trackers, technique assessment forms, musicality rubrics, performance-quality checklists, turn and leap evaluations, self-evaluations, and goal-setting pages.',
  benefit: 'Track it. Measure it. Show students their own progress — and watch their motivation grow.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-dark-card border-y border-dark-border" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-19">
            Included at no additional cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold" data-id="element-20">
            🎁 The 5 Strategic Bonuses
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-21">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-black border border-gold/20 rounded-2xl p-8 relative group hover:border-gold/50 transition-colors" data-id="element-22">
              <div className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-23">
                BONUS {bonus.id}
              </div>

              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-24">
                <Gift size={24} data-id="element-25" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16" data-id="element-26">
                {bonus.title}
              </h3>

              <div className="inline-block bg-white/5 px-3 py-1 rounded mb-4" data-id="element-27">
                <span className="text-gray-400 text-sm" data-id="element-28">
                  Real value:{' '}
                  <span className="line-through" data-id="element-29">${bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-30">→ FREE</span>
              </div>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-31">
                {bonus.desc}
              </p>

              <p className="text-gold-light text-sm italic font-medium" data-id="element-32">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold-dark/20 via-gold/10 to-gold-dark/20 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-33">
          <p className="text-gray-300 mb-2" data-id="element-34">Total value of the 5 bonuses</p>
          <p className="text-2xl text-gray-500 line-through mb-4" data-id="element-35">$58.00</p>
          <p className="text-lg text-white mb-2" data-id="element-36">Your price today</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-37">🎁 FREE</p>
          <p className="text-sm text-gold-light" data-id="element-38">
            Only included in this offer.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-39" />
      </div>
    </section>;
}